import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getKeywords() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/keyword/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setKeywordsList(json));
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function setKeywordsList(keywords) {
	return {
		type: "SET_KEYWORDS_LIST",
		keywords
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/keywords/actions.js